import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentService } from 'src/app/content.service';
import { AuthService } from 'src/app/auth.service';
import { SanityService } from 'src/app/sanity.service';
import { Kontaktperson } from 'src/app/types/sanity.types';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-landingsside-maskinist',
  templateUrl: './landingsside-maskinist.component.html',
  styleUrls: ['./landingsside-maskinist.component.scss']
})
export class LandingssideMaskinistComponent implements OnInit {
  public maskinist: any;
  public mineforestillinger$!: Observable<any>;
  public kjoreplan: any[] = [];
  public maskinister: any[] = [];
  public brukerveiledninglenke: string = '';
  public henterKjoreplan = false;
  public kontaktAdm: Kontaktperson[] = [];
  public kontaktTeknisk: Kontaktperson[] = [];

  constructor(
    private contentService: ContentService,
    public auth: AuthService,
    private sanityService: SanityService
  ) {}

  ngOnInit() {
    this.maskinist = this.auth.getUserInfo();
    this.mineforestillinger$ = this.contentService.fetchContent('/salg/mineforestillinger');
    this.hentMaskinister();
    this.hentKjoreplan();
    this.hentKontaktpersoner();
  }

  hentKjoreplan() {
    this.henterKjoreplan = true;
    this.contentService.fetchContent('/maskinist/' + this.maskinist.maskinist + '/kjoreplan/?limit=7')
      .subscribe((res: any) => {
        this.kjoreplan = res;
        this.henterKjoreplan = false;
      });
  }

  hentBrukerveiledninglenke() {
    let backendurl = environment.production ? window.origin : 'http://localhost:5000';
    this.brukerveiledninglenke = backendurl + '/static/doc/kinologg_brukerveiledning.pdf';
    return this.brukerveiledninglenke;
  }

  hentMaskinister() {
    this.contentService.getSearchResult('/maskinist', 'navn', '', '"aktivpassiv":"true"')
    .subscribe(maskinister => {
      this.maskinister = maskinister._items;
      this.maskinister.forEach((m: any) => {
        this.contentService.lookupPostnummer(m.postnr)
          .subscribe(res => {
            m.poststed = res.result;
          })
      })
    });
  }

  hentKontaktpersoner() {
    this.sanityService
      .fetch<Kontaktperson[]>(`*[_type == "kontaktperson"] | order(name asc)`)
      .subscribe(kontakter => {
        this.kontaktAdm = kontakter.filter(k => k.avdeling === 'administrasjon');
        this.kontaktTeknisk = kontakter.filter(k => k.avdeling === 'teknisk');
      });
  }

}
